/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - SalesData Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import { Chip, IconButton, List, ListItem, ListItemText } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useSalesData from "hooks/useSalesData";
import formatRupee from "../../../utils/formatHelper.js";
const formatDateIndian = (isoString) => {
  const date = new Date(isoString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Ensures AM/PM format
  });
};
export default function data() {
  const navigate = useNavigate();
  const { deletePurchase, salesDataList, getsalesDataList } = useSalesData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});
  const [open, setOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openDialogHandler = (data) => {
    setSelectedData(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedData(null);
  };

  const handleDeleteSales = async (purchaseId) => {
    if (window.confirm("Are you sure you want to delete this purchase?")) {
      // setLoading((prev) => ({ ...prev, [purchaseId]: { ...prev[purchaseId], delete: true } }));
      try {
        const res = await deletePurchase(purchaseId);
        if (res.success) {
          alert("Purchase deleted successfully!");
          getsalesDataList({ limit: salesDataList.limit, page: salesDataList.page });
        }
      } catch (err) {
        console.error("Error deleting purchase:", err);
        alert("An error occurred while deleting the purchase.");
      } finally {
        // setLoading((prev) => ({ ...prev, [purchaseId]: { ...prev[purchaseId], delete: false } }));
      }
    }
  };

  const Actions = ({ onPreview, onDelete }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton variant="contained" color="info" sx={{ mr: 1 }} onClick={onPreview}>
        Preview
      </MDButton>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        BackdropProps={{
          style: { backgroundColor: "hsla(0, 0.00%, 0.00%, 0.12)" }, // Light transparent background
        }}
      >
        <DialogTitle>
          {selectedData?.name}
          <IconButton onClick={handleClose} sx={{ position: "absolute", right: 10, top: 10 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Invoice:
              </MDTypography>
              <MDTypography variant="h6" fontWeight="bold">
                {selectedData?.invoice}
              </MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Date:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.date}</MDTypography>
            </MDBox>
            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Last Synced:
              </MDTypography>
              <MDTypography variant="h6">{formatDateIndian(selectedData?.updatedAt)}</MDTypography>
            </MDBox>
            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Dealer:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.dealer?.bussinessName}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                GST No:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.dealer?.gstNo}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Territory:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.territory?.name}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Sales Representative:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.salesrep?.userId?.name}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Distributor:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.distributer?.name}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Town:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.town}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Remarks:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.remarks}</MDTypography>
            </MDBox>

            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Total Price:
              </MDTypography>
              <MDTypography variant="h6">{selectedData?.totalPrice}</MDTypography>
            </MDBox>

            <MDTypography variant="h6" gutterBottom>
              Product Details
            </MDTypography>

            {selectedData?.products.map((product, index) => (
              <MDBox key={index} sx={{ border: 1, borderRadius: 2, overflow: "hidden", mb: 2 }}>
                <MDBox sx={{ bgcolor: "grey.200", p: 2, borderBottom: 1 }}>
                  <MDBox
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <MDTypography variant="subtitle1">{product.product.name}</MDTypography>
                    <Chip label={`Qty: ${product.quantity}`} color="primary" />
                  </MDBox>
                </MDBox>
                <MDBox sx={{ p: 2 }}>
                  <MDTypography variant="body2" color="textSecondary" gutterBottom>
                    Category: {product.category.name}
                  </MDTypography>
                  <MDTypography variant="body2">Purchase Rate: {product.purchaseRate}</MDTypography>
                  <MDTypography variant="body2">Billing Rate: {product.billingRate}</MDTypography>
                  <MDTypography variant="body2">
                    Purchase Amount: {product.purchaseAmount}
                  </MDTypography>
                  <MDTypography variant="body2">Actual Rate: {product.actualRate}</MDTypography>
                </MDBox>
              </MDBox>
            ))}
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <MDButton variant="contained" color="error" onClick={onDelete} sx={{ mr: 1 }}>
        <DeleteIcon />
      </MDButton>
    </MDBox>
  );

  const rows = data.map((salesData) => ({
    invoiceNumber: salesData.invoice,
    date: salesData.date,
    dealerName: salesData.dealer.bussinessName,
    gst: salesData.gstNo,
    productCount: salesData.products.length,
    totalPrice: formatRupee(salesData.totalPrice),
    distributer: salesData.distributer.name,
    salesrep: salesData.salesrep.userId.name,
    territory: salesData.territory.name,
    town: salesData.town,
    actions: (
      <Actions
        onPreview={() => openDialogHandler(salesData)}
        onDelete={() => handleDeleteSales(salesData._id)}
      />
    ),
  }));

  // Commented out real data fetching
  useEffect(() => {
    if (salesDataList.sales) {
      setData(salesDataList.sales);
    }
  }, [salesDataList]);

  return {
    columns: [
      { Header: "Invoice", accessor: "invoiceNumber", align: "center" },
      { Header: "Date", accessor: "date", align: "center" },
      { Header: "Dealer Name", accessor: "dealerName", align: "center" },
      { Header: "GST", accessor: "gst", align: "center" },
      { Header: "Product Count", accessor: "productCount", align: "center" },
      { Header: "Total Price", accessor: "totalPrice", align: "center" },
      { Header: "Distributor", accessor: "distributer", align: "center" },
      { Header: "Sales Rep", accessor: "salesrep", align: "center" },
      { Header: "Territory", accessor: "territory", align: "center" },
      { Header: "Town", accessor: "town", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
